




































import { Component, Vue } from "vue-property-decorator";
import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { hotelInfo, auth } from "@/config/host.config";
import { IHotelInfo } from "@/@types/hotel-info/info";
import { IGuest } from "@/@types/admin/guest/user";

import FullHotelInfoList from "@/components/tables/hotel-info/full-hotel-info-list.vue";
import HistoryHotelInfoGraph from "@/components/graphs/history-hotel-info-graph.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import ButtonBack from "@/components/buttons/button-back.vue";

@Component({
  components: {
    HistoryHotelInfoGraph,
    FullHotelInfoList,
    InputSearch,
    ButtonBack,
  },
})
export default class HotelInfoHistory extends Vue {
  infoList: Array<IHotelInfo> = [];
  users: Array<IGuest> = [];
  id = "";
  search = "";

  get infos(): Array<IHotelInfo> {
    return this.infoList.filter((item: IHotelInfo) => {
      return (
        this.$getLocale(item.name)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) > -1
      );
    });
  }

  get hotelInfo(): IHotelInfo | null {
    const data = this.infoList.find((item: IHotelInfo) => item._id === this.id);
    return data ? data : null;
  }

  revert(info: IHotelInfo, history: Partial<IHotelInfo>): void {
    if (!info._id) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
      return;
    }
    this.$emit("updateInfo", info, history);
    this.$nextTick(() => {
      this.startCreateHotelInfoList();
    });
  }

  quickChangeShow(id: string | undefined): void {
    if (!id) return;
    const info = this.infoList.find((el) => el._id == id);
    if (!info) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
      return;
    }

    const newInfo = Object.assign({}, info);
    newInfo.show = !info.show;
    const data = { show: newInfo.show };
    this.$emit("updateInfo", data, newInfo);
  }

  async getHotelInformation(): Promise<Array<IHotelInfo>> {
    const uri = hotelInfo.mainAPI;
    const config: AxiosRequestConfig = {
      params: { history: true },
    };
    return new Promise<Array<IHotelInfo>>((res, rej) => {
      this.$axios
        .get(uri, config)
        .then((infoRes: AxiosResponse<Array<IHotelInfo>>) => {
          if (infoRes.status === 200) res(infoRes.data);
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  async getUsers(): Promise<Array<IGuest>> {
    const uri = auth.getUser;
    const config: AxiosRequestConfig = {
      params: { history: true },
    };
    return new Promise<Array<IGuest>>((res, rej) => {
      this.$axios
        .get(uri, config)
        .then((users: AxiosResponse<Array<IGuest>>) => {
          if (users.status === 200) res(users.data);
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  startCreateHotelInfoList(): void {
    this.getHotelInformation()
      .then((info: Array<IHotelInfo>) => {
        this.infoList = info;
      })
      .then(() => {
        this.getUsers().then((users: Array<IGuest>) => {
          this.users = users;
        });
      })
      .catch((e: AxiosError) => console.log(e));
  }

  mounted(): void {
    this.$emit("changeShowDemo", false);
    this.startCreateHotelInfoList();
  }

  destroyed(): void {
    this.$emit("changeShowDemo", true);
    this.infoList = [];
    this.users = [];
    this.id = "";
    this.search = "";
  }
}
